export default "__VITE_ASSET__BEfrXmdh__"